// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-dialog-actions {
  margin: 0;
}

h2 {
  text-align: center;
  background-color: var(--dim-white);
  padding: 10px;
  border-radius: 5px;
}

mat-divider {
  margin: 1rem 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/add-cv/delete-cv-lang-dialog/delete-cv-lang-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF;;AAEA;EACE,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;AACF","sourcesContent":[".mat-dialog-actions {\r\n  margin: 0;\r\n}\r\n\r\nh2 {\r\n  text-align: center;\r\n  background-color: var(--dim-white);\r\n  padding: 10px;\r\n  border-radius: 5px;\r\n}\r\n\r\nmat-divider {\r\n  margin: 1rem 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
